import { Button } from "@svea/design-system-components-react";
import type { ProductSkuValue } from "@sveabank/cc-common";
import { Stack, useText } from "@sveabank/cc-common";
import { useState } from "react";
import { usePageContext } from "../../../hooks/context";
import { useApplicationId } from "../../../hooks/useApplicationId";
import { useChoosePackage } from "../hooks";
import RemoveCreditProductModal from "./remove-credit-product-modal";

const CreditConfigRemove = ({
	name,
	isAddon,
	sku,
}: {
	name: string;
	isAddon: boolean;
	sku: ProductSkuValue;
}) => {
	const [t, texts] = useText();
	const [modalOpen, setModalOpen] = useState(false);
	const { useRemoveAddonMutation } = usePageContext(useChoosePackage);
	const applicationId = useApplicationId();
	const [removeAddonMutation, { isLoading: isLoadingRemoveAddon }] = useRemoveAddonMutation();

	const onRemove = async () => {
		await removeAddonMutation({ applicationId, addonIds: [name] }).unwrap();
		setModalOpen(false);
	};

	return (
		<Stack direction="row" align="start" justify="end">
			{isAddon && (
				<Button
					data-testid={`remove-${sku}`}
					variant="plain"
					onPress={() => {
						setModalOpen(true);
					}}
					type="button"
					iconStart="trash"
				>
					{t(texts.common.remove)}
				</Button>
			)}
			<RemoveCreditProductModal
				sku={sku}
				isOpen={modalOpen}
				onRemove={onRemove}
				setOpen={setModalOpen}
				isLoadingRemoveAddon={isLoadingRemoveAddon}
			/>
		</Stack>
	);
};

export default CreditConfigRemove;
